
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.439 11.382l.006-.032c.132-.533.298-1.197.169-1.8a.776.776 0 00-.748-.673c-.36-.015-.68.185-.76.477-.15.536-.015 1.267.23 2.2-.309.722-.802 1.772-1.163 2.396-.673.341-1.575.868-1.71 1.532a.64.64 0 00.08.42.715.715 0 00.375.334c.068.024.15.045.246.045.4 0 1.047-.317 1.911-1.771.132-.042.268-.087.4-.131.618-.206 1.26-.42 1.839-.516.64.337 1.37.553 1.866.553.49 0 .684-.285.756-.457.128-.3.066-.68-.14-.883-.3-.29-1.03-.366-2.166-.227-.56-.335-.925-.79-1.191-1.467zm-2.494 3.387c-.315.45-.554.675-.684.774.153-.275.45-.565.684-.774zm1.991-5.252c.119.199.103.799.012 1.102-.112-.444-.128-1.073-.062-1.146.019.002.034.015.05.044zM7.9 12.204c.243.413.55.767.889 1.03-.491.11-.939.29-1.339.451l-.28.111a13.14 13.14 0 00.73-1.592zm3.536 1.46c.003.005.005.012-.009.021h-.004l-.005.007c-.018.01-.204.118-1.007-.192.923-.043 1.023.163 1.025.165zm4.35-8.656L10.896.21a.733.733 0 00-.514-.21H.727A.72.72 0 000 .714v18.552a.72.72 0 00.727.714h14.546a.72.72 0 00.727-.714V5.515a.71.71 0 00-.214-.507zm-1.463.834h-4.277V1.646l4.277 4.196zm.04 12.533H1.637V1.605H8.5v4.817c0 .249.1.487.28.662a.964.964 0 00.675.275h4.909v11.016z","fill":"currentColor"}})])
          )
        }
      }
    